// Frost and warmth on the frosty mochi, per vertex: frost (0..1) and warmth
// (0..1). Cold skin is pale, bluish and matte; warm skin returns to the toy's
// own colour and gloss. Frost is branching ice rather than powder: ridged
// noise gives vein-like lines, the strongest first, so the lines grow in as the
// frost thickens, over a faint haze with a few glints. Patterns come from the
// rest position, so they stay put while the mochi squashes.
export function applyFrostShading(material){
  const previous=material.onBeforeCompile;
  material.onBeforeCompile=(shader,renderer)=>{
    previous?.call(material,shader,renderer);
    shader.vertexShader=shader.vertexShader
      .replace('#include <common>','#include <common>\nattribute float frost;\nattribute float warmth;\nattribute vec3 restPosition;\nvarying float vFrost;\nvarying float vWarmth;\nvarying vec3 vFrostRest;')
      .replace('#include <begin_vertex>','#include <begin_vertex>\nvFrost=frost;vWarmth=warmth;vFrostRest=restPosition;');
    shader.fragmentShader=shader.fragmentShader
      .replace('#include <common>',`#include <common>
varying float vFrost;varying float vWarmth;varying vec3 vFrostRest;
float frostHash(vec3 p){p=fract(p*.3183099+.1);p*=17.;return fract(p.x*p.y*p.z*(p.x+p.y+p.z));}
float frostNoise(vec3 x){vec3 i=floor(x),f=fract(x);f=f*f*(3.-2.*f);
  return mix(mix(mix(frostHash(i),frostHash(i+vec3(1,0,0)),f.x),mix(frostHash(i+vec3(0,1,0)),frostHash(i+vec3(1,1,0)),f.x),f.y),
    mix(mix(frostHash(i+vec3(0,0,1)),frostHash(i+vec3(1,0,1)),f.x),mix(frostHash(i+vec3(0,1,1)),frostHash(i+vec3(1,1,1)),f.x),f.y),f.z);}
float frostRidge(vec3 p){return 1.-abs(2.*frostNoise(p)-1.);}`)
      .replace('#include <color_fragment>',`#include <color_fragment>
float frostWarm=clamp(vWarmth,0.,1.);
float frostGrey=dot(diffuseColor.rgb,vec3(.3,.55,.15));
vec3 frostCold=mix(vec3(frostGrey),diffuseColor.rgb,.35)*vec3(.80,.90,1.12)+vec3(.04,.05,.08);
diffuseColor.rgb=mix(frostCold,diffuseColor.rgb,smoothstep(.05,.8,frostWarm));
vec3 frostP=vFrostRest*13.;
float frostIce=pow(frostRidge(frostP),4.)*.6+pow(frostRidge(frostP*2.1+3.7),4.)*.3+pow(frostRidge(frostP*4.3+7.1),4.)*.15;
float frostAmount=clamp(vFrost,0.,1.);
float frostLines=smoothstep(1.02-.6*frostAmount,1.08-.6*frostAmount,frostIce/1.05)*step(.02,frostAmount);
float frostMask=clamp(max(frostLines,frostAmount*.28),0.,1.);
diffuseColor.rgb=mix(diffuseColor.rgb,vec3(.92,.96,1.),frostMask*.9);
float frostGlint=step(.975,frostHash(floor(vFrostRest*150.)))*frostLines;`)
      .replace('#include <roughnessmap_fragment>','#include <roughnessmap_fragment>\nroughnessFactor=mix(mix(.62,roughnessFactor,smoothstep(.2,.9,frostWarm)),.85,frostMask);')
      .replace('#include <lights_physical_fragment>','#include <lights_physical_fragment>\n#ifdef USE_CLEARCOAT\nmaterial.clearcoat*=smoothstep(.15,.9,frostWarm)*(1.-frostMask);\n#endif')
      .replace('#include <emissivemap_fragment>','#include <emissivemap_fragment>\ntotalEmissiveRadiance+=vec3(.8,.9,1.)*frostGlint*.7;');
  };
  const key=material.customProgramCacheKey?.bind(material);
  material.customProgramCacheKey=()=>`${key?key():''}|frost`;
  material.needsUpdate=true;
  return material;
}
